import {
  getTaskForProjectConfirmation,
  getTaskForUnProjectConfirmation,
  needHelpPerson
} from '@/api/compositeAssit.js'
import { addOrUpdateHelpPersonForPage } from '@/api/assitTarget'
import moment from 'moment'
import lodash from 'lodash'
function handleData(params = {}) {
  // formData
  const data = lodash.cloneDeep(params)
  let initData = {}
  const baseData = data.baseData
  const familyData = data.familyData
  baseData.need_help_person_birthday = baseData.need_help_person_birthday
    ? moment(baseData.need_help_person_birthday).format('YYYY-MM-DD')
    : ''
  baseData.need_help_person_ensureDate = baseData.need_help_person_ensureDate
    ? moment(baseData.need_help_person_ensureDate._d).format('YYYY-MM-DD')
    : ''
  initData = { ...data.assitTargetInfo, ...baseData, ...familyData }
  return initData
}
export const service = {
  needHelpPerson(data) {
    // 获取帮扶对象数据
    return new Promise((resolve, reject) => {
      needHelpPerson(data)
        .then((response) => {
          resolve(response || [])
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getTaskForProject(data) {
    // 获取帮扶对象项目关联
    return new Promise((resolve, reject) => {
      getTaskForProjectConfirmation(data)
        .then((response) => {
          if (response) {
            const data = lodash.cloneDeep(response || [])
            for (let i = 0; i < data.length; i++) {
              if (data[i].process_base_status) {
                if (data[i].process_base_status === 'Approval') {
                  data[i].process_status = '待审批'
                } else if (data[i].process_base_status === 'Draft') {
                  data[i].process_status = '申请中'
                } else if (data[i].process_base_status === 'Finish') {
                  data[i].process_status = '待发放'
                } else if (data[i].process_base_status === 'ReturnDraft') {
                  data[i].process_status = '退回（申请中）'
                } else if (data[i].process_base_status === 'Termination') {
                  data[i].process_status = '终止'
                } else if (data[i].process_base_status === 'IsFinished') {
                  data[i].process_status = '待发放'
                } else if (data[i].process_base_status === 'Finished') {
                  data[i].process_status = '已完成'
                }
              }
            }
            resolve(data)
          } else {
            resolve([])
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getTaskForUnProject(data) {
    // 获取帮扶对象任务
    return new Promise((resolve, reject) => {
      getTaskForUnProjectConfirmation(data)
        .then((response) => {
          if (response) {
            const data = lodash.cloneDeep(response || [])
            for (let i = 0; i < data.length; i++) {
              data[i].time = data[i].process_base_draft_date
              if (data[i].process_base_status) {
                if (data[i].process_base_status === 'Approval') {
                  data[i].process_status = '待审批'
                } else if (data[i].process_base_status === 'Draft') {
                  data[i].process_status = '申请中'
                } else if (data[i].process_base_status === 'Finish') {
                  data[i].process_status = '待发放'
                } else if (data[i].process_base_status === 'ReturnDraft') {
                  data[i].process_status = '退回（申请中）'
                } else if (data[i].process_base_status === 'Termination') {
                  data[i].process_status = '终止'
                } else if (data[i].process_base_status === 'IsFinished') {
                  data[i].process_status = '待发放'
                } else if (data[i].process_base_status === 'Finished') {
                  data[i].process_status = '已完成'
                }
              }
              if (data[i].process_config_type) {
                if (data[i].process_config_type === 'releaseOfFunds') {
                  data[i].process_type = '资金帮扶'
                } else if (data[i].process_config_type === 'activityConfirmation') {
                  data[i].process_type = '活动帮扶'
                } else if (data[i].process_config_type === 'individualCase') {
                  data[i].process_type = '个案帮扶'
                } else if (data[i].process_config_type === 'ghReleaseOfFunds') {
                  data[i].process_type = '资金帮扶-帮侬一把'
                } else if (data[i].process_config_type === 'ghActivityConfirmation') {
                  data[i].process_type = '活动帮扶-帮侬一把'
                } else if (data[i].process_config_type === 'internalDocuments') {
                  data[i].process_type = '内部文件'
                }
              }
            }
            resolve(data)
          } else {
            resolve([])
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  increaseAssitTarget(data) {
    // 新增帮扶对象
    return new Promise((resolve, reject) => {
      const params = handleData(data)
      addOrUpdateHelpPersonForPage(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
